module.exports = __webpack_public_path__ + "static/media/galerija_2013 (18).cf5fb196.JPG";